import { styled } from '@mui/system'

export const Icon = styled('img')`
  height: 120px;
  margin: 0 auto ${({ theme }) => theme.spacing(5)} auto;
`
